import React from 'react'
import { Controller } from 'react-hook-form'
import { isPhoneValid } from '../../../utils/validators'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { useUserFormContext } from '../utils/userFormContext'
import { NO_PHONE_VALUE } from '../../Common/form/_utils/utils'
import { HIDDEN_PHONE_VALUE } from './_utils'

type ContactPhoneProps = {
    isDisabled?: boolean
}

export const ContactPhone = ({ isDisabled = false }: ContactPhoneProps) => {
    const { control } = useFormContextUser()
    const { state } = useUserFormContext()

    const label = 'Numéro de téléphone professionnel (visible par les utilisateurs)'

    return (
        <Controller
            control={control}
            name="contactPhone"
            rules={{
                validate: (val) => (isDisabled ? undefined : isPhoneValid(val, false)),
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label={isDisabled ? label.split('(')[0] : label}
                    {...field}
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    placeholder="00 00 00 00 00"
                    data-cy={`dataCy_UserField-${field.name}`}
                    value={state.isEditionMode && isDisabled ? HIDDEN_PHONE_VALUE : field.value}
                    noValueText={NO_PHONE_VALUE}
                    disabled={isDisabled}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}
